import { axiosInstanceHelpDesk } from "./instance";

export const ratingTicket = (id, ticketRating) => {
    return axiosInstanceHelpDesk.put(`/funnel/ticket/rating-ticket/${id}/${ticketRating}`);
  };